import { formatDateTime } from '../../components/audit/auditUtils';
import { TypedStatusBadge } from '../../components/common/StatusBadge';
import { formatRelativeTime } from '../../lib/formatters';
import type { AuditDetail } from '../../stores/auditManagementStore';
import { selectAudit } from '../../stores/auditManagementStore';

export const useAuditColumns = () => {
  return [
    {
      key: 'timestamp',
      header: 'Timestamp',
      headerClassName: 'text-xs font-semibold text-neutral-300',
      size: 140,
      enableSorting: true,
      sortDescFirst: true,
      accessor: (row: AuditDetail) => (
        <div className="space-y-0.5">
          <div className="text-xs text-neutral-400">
            {formatRelativeTime(row.createdAt)}
          </div>
          <div className="text-xs text-neutral-500">
            {formatDateTime(row.createdAt)}
          </div>
        </div>
      ),
    },
    {
      key: 'user',
      header: 'User',
      headerClassName: 'text-xs font-semibold text-neutral-300',
      size: 200,
      enableSorting: false,
      accessor: (row: AuditDetail) => (
        <div className="space-y-1">
          {row.user ? (
            <>
              <div className="text-sm font-medium text-white truncate">
                {row.user.fullName}
              </div>
              <div className="text-xs text-neutral-400 truncate">
                {row.user.email}
              </div>
            </>
          ) : (
            <span className="text-sm text-neutral-400">System</span>
          )}
        </div>
      ),
    },
    {
      key: 'action',
      header: 'Action',
      headerClassName: 'text-xs font-semibold text-neutral-300',
      size: 220,
      enableSorting: false,
      accessor: (row: AuditDetail) => (
        <span className="text-sm font-mono text-white break-words">
          {row.action}
        </span>
      ),
    },
    {
      key: 'entity',
      header: 'Entity',
      headerClassName: 'text-xs font-semibold text-neutral-300',
      size: 220,
      enableSorting: false,
      accessor: (row: AuditDetail) => (
        <div className="space-y-1">
          {row.entityType ? (
            <>
              <div className="text-sm font-medium text-white">
                {row.entityType}
              </div>
              {row.entityId && (
                <div className="text-xs text-neutral-400 font-mono truncate">
                  {row.entityId.slice(0, 24)}...
                </div>
              )}
            </>
          ) : (
            <span className="text-sm text-neutral-500">—</span>
          )}
        </div>
      ),
    },
    {
      key: 'status',
      header: 'Status',
      headerClassName: 'text-xs font-semibold text-neutral-300',
      size: 120,
      enableSorting: true,
      accessor: (row: AuditDetail) => (
        <TypedStatusBadge type="audit" status={row.status} />
      ),
    },
    {
      key: 'duration',
      header: 'Duration',
      headerClassName: 'text-xs font-semibold text-neutral-300',
      size: 100,
      enableSorting: true,
      accessor: (row: AuditDetail) => (
        <span className="text-sm text-neutral-400">
          {row.duration ? `${row.duration}ms` : '—'}
        </span>
      ),
    },
    {
      key: 'details',
      header: 'Details',
      headerClassName: 'text-xs font-semibold text-neutral-300',
      size: 100,
      enableSorting: false,
      accessor: (row: AuditDetail) => (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            selectAudit(row.id);
          }}
          className="text-teal-500 hover:text-teal-400 text-sm font-medium transition-colors"
        >
          View
        </button>
      ),
    },
  ];
};
